import {dijkstra} from './dijkstra.js';
import {bellmanFord} from './bellman-ford.js';
import {Graph} from '../graph.js';
import type {EdgeFunction, Path, WeightFunction} from '../types.js';

export function shortestPaths(
    g: Graph,
    source: string,
    weightFn?: WeightFunction,
    edgeFn?: EdgeFunction
): Record<string, Path> {
    return runShortestPaths(
        g,
        source,
        weightFn,
        edgeFn ?? ((v: string) => {
            return g.outEdges(v) ?? [];
        })
    );
}

function runShortestPaths(
    g: Graph,
    source: string,
    weightFn: WeightFunction | undefined,
    edgeFn: EdgeFunction
): Record<string, Path> {
    if (weightFn === undefined) {
        return dijkstra(g, source, weightFn, edgeFn);
    }

    let negativeEdgeExists = false;
    const nodes = g.nodes();

    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (node === undefined) continue;
        const adjList = edgeFn(node);

        for (let j = 0; j < adjList.length; j++) {
            const edge = adjList[j];
            if (!edge) continue;
            const inVertex = edge.v === node ? edge.v : edge.w;
            const outVertex = inVertex === edge.v ? edge.w : edge.v;

            if (weightFn({v: inVertex, w: outVertex}) < 0) {
                negativeEdgeExists = true;
            }
        }

        if (negativeEdgeExists) {
            return bellmanFord(g, source, weightFn, edgeFn);
        }
    }

    return dijkstra(g, source, weightFn, edgeFn);
}
